module.exports = __webpack_public_path__ + "static/img/digiCULT_logo_website_colorless.070bd2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/digiCULT_logo_website_colorless.svg
// module id = L81l
// module chunks = 0